"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataEqual = void 0;
var engine_utils_1 = require("@verified/c11-engine.utils");
var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
var isArray_1 = __importDefault(require("lodash/isArray"));
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var isObject_1 = __importDefault(require("lodash/isObject"));
var getOperation_1 = require("./getOperation");
var updateOperation_1 = require("./updateOperation");
// TODO: this needs to go only a few levels deep - it shouldn't compare through the actual data
var removeOperations = function (data, serializers, result, set) {
    if (result === void 0) { result = {}; }
    if (set === void 0) { set = new WeakSet(); }
    var serializer = serializers.find(function (x) {
        return x.instanceof && data instanceof x.instanceof === true;
    });
    if (serializer) {
        result = serializer.serializer(data);
    }
    else if ((0, isObject_1.default)(data)) {
        Object.entries(data).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value &&
                value.__operation__ &&
                value.__operation__.symbol &&
                value.__operation__.id &&
                (0, isFunction_1.default)(value.__operation__.symbol.toString) &&
                // the toString() conversation is due to the way clone-deep works
                // and clones Symbols - this should be removed in future releases
                // when the data clonning approach is revisited
                (value.__operation__.symbol.toString() ===
                    updateOperation_1.UpdateOperationSymbol.toString() ||
                    value.__operation__.symbol.toString() ===
                        getOperation_1.GetOperationSymbol.toString())) {
                result[key] =
                    value.__operation__.symbol.toString() + value.__operation__.id;
            }
            else {
                if ((0, isObject_1.default)(value)) {
                    if (!result[key]) {
                        result[key] = {};
                    }
                    if (set.has(value)) {
                        result[key] = value;
                    }
                    else {
                        set.add(value);
                        result[key] = removeOperations(value, serializers, result[key], set);
                    }
                }
                else {
                    result[key] = value;
                }
            }
        });
    }
    else {
        result = data;
    }
    return result;
};
var isDataEqual = function (prevData, data, serializers) {
    // const rawPrevData = removeOperations(prevData, serializers);
    // const rawData = removeOperations(data, serializers);
    // const result = isEqual(rawPrevData, rawData);
    var replacer = function (key, value) {
        if ((0, isPlainObject_1.default)(value) || (0, isArray_1.default)(value) || value !== Object(value)) {
            return value;
        }
        else if (typeof value === "symbol" || value instanceof Symbol) {
            return value.toString();
        }
        return (0, engine_utils_1.randomId)();
    };
    var result = JSON.stringify(prevData, replacer) === JSON.stringify(data, replacer);
    return result;
};
exports.isDataEqual = isDataEqual;
//# sourceMappingURL=data:application/json;base64,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